import { baseVueI18n } from '@/plugins/vue-i18n'
import { BaseTableEntities } from '@/types'

const flpTables: BaseTableEntities = {
  holeriteSnapshot: [
    {
      value: 'titulo',
      text: '',
      hidden: true
    },
    {
      value: 'periodo',
      text: '',
      index: -1,
      formatter: (value, rootValue) => ((value !== undefined) && (value !== null))
        ? `${baseVueI18n.df(new Date(value), { pattern: 'MM/yyyy', timeZone: 'UTC' })}${rootValue.numeroRecibo ? ' - ' + rootValue.numeroRecibo : ''}`
        : value
    },
    {
      value: 'numeroRecibo',
      text: '',
      hidden: true
    },
    {
      value: 'empregador',
      text: '',
      formatter: (value) => value ? `${value.razaoSocial} | ${value.inscricao}` : value
    },
    {
      value: 'colaborador',
      text: '',
      formatter: (value) => value ? `${value.nome} | ${value.cpf}` : value
    },
    {
      value: 'rubricas',
      text: '',
      hidden: true
    },
    {
      value: 'salarioBase',
      text: '',
      hidden: true
    },
    {
      value: 'baseCalculoIrrf',
      text: '',
      hidden: true
    },
    {
      value: 'baseCalculoInss',
      text: '',
      hidden: true
    },
    {
      value: 'baseCalculoFgts',
      text: '',
      hidden: true
    },
    {
      value: 'valorFgts',
      text: '',
      hidden: true
    },
    {
      value: 'observacoes',
      text: '',
      hidden: true
    },
    {
      value: 'checksum',
      text: '',
      auditing: true
    },
    {
      value: 'firstViewDatetime',
      text: '',
      hidden: {
        holeriteSnapshotUserContext: true
      }
    }
  ],
  informeRendimentoSnapshot: [
    {
      value: 'ano',
      text: '',
      align: 'start'
    },
    {
      value: 'empregador',
      text: '',
      formatter: (value) => value ? `${value.razaoSocial} | ${value.inscricao}` : value
    },
    {
      value: 'colaborador',
      text: '',
      formatter: (value) => value ? `${value.nome} | ${value.cpf}` : value
    },
    {
      value: 'naturezaRendimento',
      text: '',
      hidden: true
    },
    {
      value: 'outrosRendimentosIsentos',
      text: '',
      hidden: true
    },
    {
      value: 'numeroProcesso',
      text: '',
      hidden: true
    },
    {
      value: 'quantidadeMesesProcesso',
      text: '',
      hidden: true
    },
    {
      value: 'naturezaRendimentoProcesso',
      text: '',
      hidden: true
    },
    {
      value: 'grupos',
      text: '',
      width: 'auto',
      align: 'end',
      chips: false,
      formatter: (value) => (value && value.length)
        ? [baseVueI18n.n(value.find((grupo: any) => grupo.descricao === '3.1')?.valor, { style: 'decimal', minimumFractionDigits: 2 })]
        : value
    },
    {
      value: 'informacoes',
      text: '',
      hidden: true
    },
    {
      value: 'responsavel',
      text: '',
      hidden: true
    },
    {
      value: 'checksum',
      text: '',
      auditing: true
    },
    {
      value: 'firstViewDatetime',
      text: '',
      hidden: {
        informeRendimentoSnapshotUserContext: true
      }
    }
  ],
  feriasSnapshot: [
    {
      value: 'periodoAquisitivo',
      text: '',
      index: -1,
      formatter: (value) => value
        ? baseVueI18n.t('flp.feriasSnapshot.field.periodoInicioFim', {
          inicio: baseVueI18n.d(new Date(value.inicio), { dateStyle: 'short', timeZone: 'UTC' }),
          fim: baseVueI18n.d(new Date(value.fim), { dateStyle: 'short', timeZone: 'UTC' })
        })
        : value
    },
    {
      value: 'periodoAquisitivoComplemento',
      text: '',
      hidden: true
    },
    {
      value: 'periodoGozo',
      text: '',
      index: -1,
      formatter: (value) => value
        ? baseVueI18n.t('flp.feriasSnapshot.field.periodoInicioFim', {
          inicio: baseVueI18n.d(new Date(value.inicio), { dateStyle: 'short', timeZone: 'UTC' }),
          fim: baseVueI18n.d(new Date(value.fim), { dateStyle: 'short', timeZone: 'UTC' })
        })
        : value
    },
    {
      value: 'empregador',
      text: '',
      formatter: (value) => value ? `${value.razaoSocial} | ${value.inscricao}` : value
    },
    {
      value: 'colaborador',
      text: '',
      formatter: (value) => value ? `${value.nome} | ${value.cpf}` : value
    },
    {
      value: 'periodoAbonoPecuniario',
      text: '',
      hidden: true
    },
    {
      value: 'coletiva',
      text: '',
      hidden: true
    },
    {
      value: 'perdida',
      text: '',
      hidden: true
    },
    {
      value: 'quantidadeDependentes',
      text: '',
      hidden: true
    },
    {
      value: 'faltasInjustificadas',
      text: '',
      hidden: true
    },
    {
      value: 'faltasDescontadas',
      text: '',
      hidden: true
    },
    {
      value: 'salarioContratual',
      text: '',
      hidden: true
    },
    {
      value: 'salarioBaseCalculo',
      text: '',
      hidden: true
    },
    {
      value: 'salarioVariavelBaseCalculo',
      text: '',
      hidden: true
    },
    {
      value: 'baseCalculo',
      text: '',
      hidden: true
    },
    {
      value: 'totalDiasAfastado',
      text: '',
      hidden: true
    },
    {
      value: 'totalDiasFalta',
      text: '',
      hidden: true
    },
    {
      value: 'demonstrativos',
      text: '',
      hidden: true
    },
    {
      value: 'dataAviso',
      text: '',
      index: -1
    },
    {
      value: 'dataRecibo',
      text: '',
      hidden: true
    },
    {
      value: 'checksum',
      text: '',
      auditing: true
    },
    {
      value: 'firstViewDatetime',
      text: '',
      hidden: {
        feriasSnapshotUserContext: true
      }
    }
  ]
}

export default flpTables